<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-button v-b-modal.modal-filter-Incoming variant="primary">
            <feather-icon icon="FilterIcon" class="mr-25" />
            <span>Filter</span>
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" />
        <b-col md="3">
          <b-form-input v-model="filter" type="search" placeholder="search" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template #table-caption>
              <h2>Incoming Messages</h2>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
          />
        </b-col>
      </b-row>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
    <b-col>
      <b-modal
        id="modal-filter-Incoming"
        ref="modal"
        hide-footer
        title="Filter Incoming messages"
        size="lg"
      >
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="filterIncomingMessage">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="System Check Type"
                  label-for="systemCheckType"
                >
                  <v-select
                    v-model="filterForm.systemCheckType"
                    label="text"
                    :options="systemCheckTypeOptions"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="Transaction Date Range"
                  label-for="IncomingMessageDateRange"
                >
                  <flat-pickr
                    v-model="IncomingMessageDateRange"
                    class="form-control"
                    :config="{ mode: 'range' }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description-input"
                    v-model="filterForm.description"
                    placeholder="Description"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="filterIncomingMessage"
            >
              Filter
            </b-button>
          </form>
        </validation-observer>
      </b-modal>
    </b-col>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCard,
  BOverlay,
  BButton,
  BFormGroup,
  BFormTextarea,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationObserver } from "vee-validate";
import axios from "@axios";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BCard,
    BOverlay,
    BButton,

    ValidationObserver,
    BFormGroup,
    vSelect,
    BFormTextarea,
    flatPickr,
  },
  data() {
    return {
      required,
      isLoading: false,
      props: ["items"],
      fields: ["transactionDate", "description", "systemCheckTypeDescription"],
      items: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      IncomingMessageDateRange: "",
      systemCheckTypeOptions: [
        { value: 0, text: "All" },
        { value: 1, text: "DataBase" },
        { value: 2, text: "API" },
        { value: 3, text: "Email" },
        { value: 4, text: "BothDatabaseAPI" },
      ],
      filterForm: {
        systemCheckType: { value: 0 },
        description: "",
        fromDate: "",
        toDate: "",
      },
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.fetchData().catch((error) => {
      console.error(error);
    });
  },
  methods: {
    filterIncomingMessage() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$refs.modal.hide();
          this.isLoading = true;
          const [from, to] = this.IncomingMessageDateRange.split(" to ");
          this.filterForm.fromDate = from;
          this.filterForm.toDate = to;

          if (this.IncomingMessageDateRange.includes("to")) {
            this.filterForm.fromDate = from;
            this.filterForm.toDate = to;
          } else {
            this.filterForm.fromDate = this.IncomingMessageDateRange;
            this.filterForm.toDate = this.IncomingMessageDateRange;
          }

          axios
            .get(
              `/Monitor/api/V1.0/Monitor/FilterIncomingFailedMessage?systemCheckType=${this.filterForm.systemCheckType.value}&description=${this.filterForm.description}&fromDate=${this.filterForm.fromDate}&toDate=${this.filterForm.toDate}`
            )
            .then((res) => {
              console.log(res.incomingFailedMessages);
              this.items = res.incomingFailedMessages;
              this.isLoading = false;
              this.$bvModal.msgBoxOk(`${res.message}`, {
                title: "Success",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(`${res.data.message}`, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Incoming-View");
      axios
        .get("/Monitor/api/V1.0/Monitor/GetIncomingMessageFailed")
        .then((res) => {
          this.items = res.incomingFailedMessages;
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
